import Button, { SIZE, COLOR, STYLE } from "./Button";

export { SIZE, COLOR, STYLE };
export default Button;
